import validateWithRules from '@utilities/json-driven-validator';

export default class ValidatorAdapter {
  execute({ value, rules }) {
    const result = validateWithRules(value, rules);
    let message = !result.isValid() ? result.getErrors()[0] : '';
    return { message, isValid: result.isValid };
  }
}
